module.exports = __webpack_public_path__ + "img/404.6b4d7eea.png";